export const STD_SESSION_IN_PAST_STRING = "This session has already occurred.";
export const STD_NO_USER_LOGIN_STRING = "You need to login to RSVP for game sessions.";
export const STD_NOT_RSVPED_EVENT_STRING = "You need to RSVP for the event first.";
export const STD_USER_NOT_PERMITTED_STRING = "You aren't allowed to RSVP for this game session.";
export const STD_NO_SLOTS_REMAINING_STRING = "There are no slots remaining for this game session.";

export const STD_RELINQUISH_BUTTON_STRING = "Relinquish";
export const STD_SIGN_UP_BUTTON_STRING = "Sign-Up";


export const PRM_SESSION_IN_PAST_STRING = "This session has already occurred.";
export const PRM_NO_USER_LOGIN_STRING = "You need to login to RSVP for game sessions.";
export const PRM_NOT_RSVPED_EVENT_STRING = "You need to RSVP for the event first.";
export const PRM_USER_NOT_PERMITTED_STRING = "You aren't allowed to RSVP for this game session.";
export const PRM_NO_SLOTS_REMAINING_STRING = "There are no slots remaining for this game session.";

export const PRM_RELINQUISH_BUTTON_STRING = "Relinquish";
export const PRM_SIGN_UP_BUTTON_STRING = "Sign-Up";